import FadeIn from 'react-fade-in/lib/FadeIn';
import React from 'react';

function ShouldFadeIn({ children, index }) {
  if (index == null) {
    return children;
  }

  return <FadeIn delay={100 + index * 80}>{children}</FadeIn>;
}

export { ShouldFadeIn };
